exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ConfigPrint textarea {\n  background: #f8f8f8;\n  color: #333;\n  font-family: monospace;\n  padding: 30px;\n  border: none;\n  width: 100%;\n  box-sizing: border-box;\n  height: calc(100vh - 250px); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/style/ConfigPrint.scss
// module id = 1707
// module chunks = 0